import type { AuthProviderProps } from 'react-oidc-context';
import { WebStorageStateStore } from 'oidc-client-ts';
import { environment } from '../utils/environment';

export const getOidcConfig = (): AuthProviderProps => {
  const clientId = environment.KEYCLOAK_CLIENT_ID || '';
  const realm = environment.KEYCLOAK_REALM || '';

  return {
    authority: `${environment.KEYCLOAK_URL}/realms/${realm}`,
    client_id: clientId,
    redirect_uri: `${window.location.origin}${window.location.search}`,
    response_type: 'code',
    scope: 'openid profile email',
    automaticSilentRenew: true,
    loadUserInfo: true,
    // Przechowuj token w localStorage zamiast sessionStorage
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    // Włącz automatyczne logowanie z zapisanego tokenu
    skipSigninCallback: false,
    // Automatycznie próbuj załadować użytkownika z localStorage przy starcie
    onSigninCallback: () => {
      window.history.replaceState({}, document.title, window.location.pathname);
    },
  };
};
